import useUserIdentity from 'hooks/useUserIdentity';

// The key we send to the backend as the acting identity: the current
// identity's uuid ('' until it's loaded).
const useWorkKey = () => {
    const { currentIdentity } = useUserIdentity();
    return currentIdentity?.uuid || '';
};

export default useWorkKey;
